export default __webpack_public_path__ + "b7768328fa2e94aa6cefc007448e567c.jpg";